import { IconProps } from '@euler/app/components/icons/types';
import { FC, memo } from 'react';
import Svg, { Defs, LinearGradient, Path, Stop } from 'react-native-svg';

export const SearchIcon: FC<
  IconProps & {
    startColor?: string;
    endColor?: string;
    active?: boolean;
  }
> = memo(
  ({
    width,
    height,
    size = 44,
    color,
    active,
    startColor,
    endColor,
    style,
  }) => {
    if (active) {
      return (
        <Svg
          width={width ?? size}
          height={height ?? size}
          viewBox="0 0 44 44"
          fill="none"
        >
          <Path
            d="M37.6245 40.8571L28.1224 31.3551C25.3796 33.4449 22.2775 34.4898 18.8163 34.4898C16.0081 34.4898 13.3959 33.8041 10.9796 32.4326C8.56323 30.9959 6.66935 29.0694 5.29792 26.653C3.86119 24.2367 3.14282 21.6245 3.14282 18.8163C3.14282 16.0081 3.86119 13.3959 5.29792 10.9796C6.66935 8.56323 8.56323 6.66935 10.9796 5.29792C13.3959 3.86119 16.0081 3.14282 18.8163 3.14282C21.6245 3.14282 24.2367 3.86119 26.653 5.29792C29.0694 6.66935 30.9959 8.56323 32.4326 10.9796C33.804 13.3959 34.4898 16.0081 34.4898 18.8163C34.4898 22.3428 33.4122 25.4775 31.2571 28.2204L40.7591 37.7224L37.6245 40.8571ZM18.7183 29.8857C21.7877 29.8857 24.4 28.8081 26.5551 26.653C28.6449 24.4979 29.6898 21.9183 29.6898 18.9143C29.6898 15.8449 28.6449 13.2653 26.5551 11.1755C24.4 9.02037 21.7877 7.94282 18.7183 7.94282C15.7143 7.94282 13.1347 9.02037 10.9796 11.1755C8.82445 13.2653 7.7469 15.8449 7.7469 18.9143C7.7469 21.9183 8.82445 24.4979 10.9796 26.653C13.1347 28.8081 15.7143 29.8857 18.7183 29.8857Z"
            fill="url(#paint0_linear_409_2680)"
          />
          <Defs>
            <LinearGradient
              id="paint0_linear_409_2680"
              x1="25.3707"
              y1="40.8571"
              x2="24.941"
              y2="5.71428"
              gradientUnits="userSpaceOnUse"
            >
              <Stop stopColor={startColor ?? color} />
              <Stop offset="1" stopColor={endColor ?? color} />
            </LinearGradient>
          </Defs>
        </Svg>
      );
    }

    return (
      <Svg
        width={width ?? size ?? 31}
        height={height ?? size ?? 32}
        viewBox="0 0 31 32"
        fill="none"
        style={style}
      >
        <Path
          d="M29.4908 30.7215C29.1003 31.112 28.4671 31.112 28.0766 30.7215L21.0093 23.6542C18.7651 25.364 16.2271 26.2189 13.3952 26.2189C11.0976 26.2189 8.96029 25.6579 6.9833 24.5358C5.00631 23.3603 3.45677 21.7841 2.33469 19.8071C1.15918 17.8301 0.571426 15.6928 0.571426 13.3952C0.571426 11.0976 1.15918 8.96031 2.33469 6.98332C3.45677 5.00632 5.00631 3.45678 6.9833 2.33471C8.96029 1.1592 11.0976 0.571442 13.3952 0.571442C15.6928 0.571442 17.8301 1.1592 19.807 2.33471C21.784 3.45678 23.3603 5.00632 24.5358 6.98332C25.6579 8.96031 26.2189 11.0976 26.2189 13.3952C26.2189 16.2805 25.3373 18.8453 23.574 21.0894L30.6413 28.1567C31.0318 28.5473 31.0318 29.1804 30.6413 29.5709L29.4908 30.7215ZM13.315 22.452C15.8263 22.452 17.9636 21.5703 19.7269 19.8071C21.4367 18.0438 22.2916 15.9332 22.2916 13.4753C22.2916 10.964 21.4367 8.85345 19.7269 7.14361C17.9636 5.38035 15.8263 4.49871 13.315 4.49871C10.8571 4.49871 8.74656 5.38035 6.9833 7.14361C5.22003 8.85345 4.3384 10.964 4.3384 13.4753C4.3384 15.9332 5.22003 18.0438 6.9833 19.8071C8.74656 21.5703 10.8571 22.452 13.315 22.452Z"
          fill={color ?? 'rgba(255, 255, 255, 0.6)'}
        />
      </Svg>
    );
  },
);
